import { Box, Link } from '@hover/blueprint';
import { heightHeader } from '@hover/tokens-brand';
import logo from '@hover/tokens-brand/assets/logo-full--primary.svg';
import React from 'react';

import { Image, Spacer } from 'src/shared/components';
import { GridArea } from 'src/shared/constants';
import { useTranslate } from 'src/shared/hooks';
import { Route } from 'src/shared/route';

import { Navigation } from './Navigation';

const Header = () => {
  const t = useTranslate('app');

  return (
    <Box
      alignItems="center"
      display="grid"
      element="header"
      gridArea={GridArea.HEADER}
      gridTemplateColumns="auto 1fr auto"
      justifyContent="center"
      justifyItems="center"
      padding={500}
    >
      <Link aria-label={t('navigation.navigateToHome')} href={Route.ROOT.path}>
        <Image
          alt={t('hoverLogoWithHoverText')}
          height={heightHeader}
          src={logo}
        />
      </Link>
      <Spacer />
      <Navigation />
    </Box>
  );
};

export { Header };
